import { isSameDay } from 'date-fns';
import { Task } from 'shared/types/task';
import { TaskType } from 'shared/types/task-base';
import { getActiveSchedule } from 'shared/utils/get-active-schedule';

export const getTaskDuration = (task: Task, today: Date) => {
  if (task.type === TaskType.Task) {
    return task.timeslot?.duration ?? 0;
  }

  const activeSchedule = getActiveSchedule(task.schedules);

  if (!activeSchedule) {
    return 0;
  }

  const todayOccurrence = activeSchedule.plannedOccurrences?.find(
    (occurrence) => isSameDay(occurrence.date, today),
  );

  if (todayOccurrence?.timeslot?.duration) {
    return todayOccurrence.timeslot.duration;
  }

  return activeSchedule.timeslot?.duration ?? 0;
};
